import { connect } from 'react-redux';
import { toastr } from 'react-redux-toastr';

import Actions from '../../actions';
import translations from '../../../translations/app-translations';

const distinctProducts = (products) => {
    const productsFilters = [];

    // eslint-disable-next-line no-restricted-syntax
    for (const product of products) {
        const filterCondition = productsFilters.findIndex((item) => item.id === product.id) === -1;
        if (filterCondition) {
            productsFilters.push(product);
        }
    }
    return productsFilters;
};

const fetchedProducts = (dispatch, locale) => dispatch(Actions.fetchProducts({ page_no: 1, locale })).then((response) => {
    const fetchedProducts = response.body;

    if (fetchedProducts.data.length === 0) {
        toastr.info(`${translations[locale]['no-products-found']}`);
    }
    dispatch(Actions.addProducts({ products: distinctProducts(fetchedProducts.data), meta: fetchedProducts.meta }));
    dispatch(Actions.hideLoader());
}, (err) => console.log(err));

const fetchedAllStoreProducts = (dispatch, locale) => dispatch(Actions.fetchAllStoreProducts({ page_no: 1, locale })).then((response) => {
    const fetchedProducts = response.body;

    if (fetchedProducts.data.length === 0) {
        toastr.info(`${translations[locale]['no-recommended-found']}`);
    }

    dispatch(Actions.addAllStoreProducts({ allStoreProducts: distinctProducts(fetchedProducts.data), meta: fetchedProducts.meta }));
    dispatch(Actions.hideLoader());
});

const mapStateToProps = (state, ownProps) => ({
    taxons: state.taxons,
    products: state.productList.products,
    allStoreProducts: state.productList.allStoreProducts,
    navigation: state.navigation,
    pageCount: state.productList.meta.total_pages,
    displayLoader: state.displayLoader,
    locale: state.locale,
    user: state.user,
    order: state.order,
    stores: state.stores.stores,
    currentStore: state.stores.currentStore,
    currentZone: state.zones.currentZone,
    availableZones: state.zones.availableZones,
});

const mapDispatchToProps = (dispatch, getState) => ({
    triggerInitialSetup: async (locale) => {
        dispatch(Actions.displayLoader());
        fetchedProducts(dispatch, locale);
        // dispatch(Actions.displayLoader());
        // fetchedAllStoreProducts(dispatch, locale);
    },

    loadStores: (locale, currentStore, storeId) => {
        dispatch(Actions.displayLoader());

        // Load stores
        dispatch(Actions.fetchStores())
            .then((response) => {
                // if (!storeId) {
                // }
                dispatch(Actions.fetchStorePayments(!currentStore.id ? response[0] : currentStore)).then(() => {
                    fetchedProducts(dispatch, locale);
                });
            });
    },

    setCurrentStore: (locale, currentStore) => {
        dispatch(Actions.displayLoader());
        dispatch(Actions.fetchStorePayments(currentStore)).then(() => {
            fetchedProducts(dispatch, locale);
        }).catch((err) => console.log(err));
    },

    loadMoreProducts: (pageNo, locale) => dispatch(Actions.fetchProducts({ page_no: pageNo, locale }))
        .then((response) => {
            const fetchedProducts = response.body;

            dispatch(Actions.appendProducts({ products: distinctProducts(fetchedProducts.data), meta: fetchedProducts.meta }));
            dispatch(Actions.hideLoader());
        }),
});

export default connect(mapStateToProps, mapDispatchToProps);



/** WEBPACK FOOTER **
 ** ./src/containers/base/base-product-list.js
 **/